module.exports = __webpack_public_path__ + "img/question-octagon-fill.52a645dc.svg";